import { render, staticRenderFns } from "./HomeFeedDiscountPackage.vue?vue&type=template&id=f63330f2&scoped=true"
import script from "./HomeFeedDiscountPackage.vue?vue&type=script&lang=js"
export * from "./HomeFeedDiscountPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63330f2",
  null
  
)

export default component.exports